<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px"
                     class="unitWidth" size="small">
                <el-form-item :label="$t('Account.storeName')">
                    <el-input v-model.trim="searchData.strName" :disabled="true"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.locatorCode')">
                    <el-input v-model.trim="searchData.sppCode"></el-input>
                </el-form-item>
                <!--<el-form-item label="库位名称">
                    <el-input v-model.trim="searchData.sppName"></el-input>
                </el-form-item>-->
                <el-form-item>
                    <el-button size="small" type="primary" @click="getSparePartPositionFcCode()">{{$t('base.search')}}</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Account.locatorList')" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()">{{$t('base.add')}}</el-button>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" border
                      @selection-change="handleSelectionChange" @sort-change="sortChange">
                <el-table-column prop="sppCode" :label="$t('Account.locatorUniqueCode')"/>
                <el-table-column prop="sppName" :label="$t('Account.locatorCode')"/>
                <el-table-column prop="remark" :label="$t('Account.remark')"/>
                <el-table-column prop="isActive" :label="$t('base.ifEnable')">
                    <template slot-scope="scope">
                        <span>{{scope.row.isActive == true ? '是' : '否'}}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="130">
                    <template slot-scope="scope">
                        <div style="display: flex;align-items: center;justify-content: center;">
                            <i class="editBtn iconfont u-youjianbianji"
                               @click=";(ifAdd = false), updatehOpen(scope.row)"/>
                            <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)"/>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination
            @size-change="paginationChange"
            @current-change="paginationCurrentChange"
            :current-page="searchParams.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="searchParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="searchParams.pageCount"
        />
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align:left">
            <el-form :model="partPosition" :rules="position" ref="position" label-width="150px" class="demo-roleForm">
                <el-form-item :label="$t('Account.locatorUniqueCode')" prop="sppCode">
                    <el-input v-model="partPosition.sppCode"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.locatorCode')" prop="sppName">
                    <el-input v-model="partPosition.sppName" :disabled="codeShow"></el-input>
                </el-form-item>
                <el-form-item :label="$t('Account.remark')">
                    <el-input v-model="partPosition.remark"></el-input>
                </el-form-item>
                <el-form-item :label="$t('base.ifEnable')">
                    <el-switch v-model="partPosition.isActive"
                               :active-text="$t('User.Yes')"
                               :inactive-text="$t('User.No')"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updatePartPosition('position')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { getSparePartPositionFcCode } from '../../../libs/api'

    export default {
        name: 'sparePartPosition',
        data() {
            return {
                searchParams: {
                    param: {},
                    pageSize: 10,
                    page: 1,
                    pageCount: 0
                },
                searchData: {
                    sppCode: '',
                    sppName: ''
                },
                tableData: [],
                partPosition: {
                    sppCode: '',
                    sppName: '',
                    remark: '',
                    strCode: '',
                    isActive: ''
                },
                position: {
                    sppCode: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    sppName: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ],
                    remark: [
                        {
                            type: 'string',
                            required: true,
                            message: this.$t('base.PleaseEnter'),
                            trigger: 'blur'
                        }
                    ]
                },
                updateShow: false,
                ifAdd: false,
                codeShow: false
            }
        },
        created() {
            this.init()
        },
        methods: {
            init() {
                if (this.$route.params.partPosition != undefined && this.$route.params.partPosition != '') {
                    this.searchData = this.$route.params.partPosition
                    sessionStorage.setItem('partPosition', JSON.stringify(this.searchData))
                } else {
                    this.searchData = JSON.parse(sessionStorage.getItem('partPosition'))
                }
                this.getSparePartPositionFcCode()
            },
            //多选框选择 返回当前已选行数据(Array)
            handleSelectionChange(val) {
                console.log(val)
            },
            //从后台获取数据,重新排序
            sortChange(val) {
                // 详细文档参考： https://element.eleme.cn/2.13/#/zh-CN/component/table
                console.log(val)
            },
            //分页
            paginationChange(val) {
                this.searchParams.pageSize = val
                this.getSparePartPositionFcCode()
            },
            paginationCurrentChange(val) {
                this.searchParams.page = val
                this.getSparePartPositionFcCode()
            },
            updatehOpen(row) {
                //ifAdd true新增、false编辑
                this.ifAdd ? this.partPosition = {} : this.partPosition = JSON.parse(JSON.stringify(row))
                this.ifAdd ? this.codeShow = false : this.codeShow = true
                this.partPosition.strCode = this.searchData.strCode
                this.updateShow = true
            },
            updatePartPosition(position) {
                this.$refs[position].validate((valid) => {
                    if (valid) {
                        //ifAdd true新增、false编辑
                        let options = {
                            method: 'POST',
                            url: this.ifAdd ? this.$api.addSparePartPosition : this.$api.editSparePartPosition,
                            data: this.partPosition
                        }
                        this.$http.request(options).then(response => {
                            if (response.status == 100) {
                                this.getSparePartPositionFcCode()
                                this.$message.success(this.ifAdd ? this.$t('base.SuccessfullyAdded') : this.$t('base.SuccessfullyUpdated'))
                                this.updateShow = false
                            } else {
                                this.$message.error(response.message)
                            }
                        })
                    } else {
                        return false
                    }
                })
            },
            deleteRow(row) {
                this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
                    confirmButtonText: this.$t('base.delete'),
                    cancelButtonText: this.$t('base.cancel'),
                    type: 'warning'
                })
                    .then(() => {
                        this.$http
                            .request({
                                method: 'POST',
                                headers: { 'content-type': 'application/json' },
                                params: { sppId: row.sppId },
                                url: this.$api.deleteSparePartPosition
                            })
                            .then(response => {
                                this.getSparePartPositionFcCode()
                                // this.$message.success(response.message);
                            })
                            .catch(err => {
                                this.getSparePartPositionFcCode()
                                // this.$message.error(err);
                            })
                    })
                    .catch(() => {
                        this.getSparePartPositionFcCode()
                        this.$message({
                            type: 'info',
                            message: this.$t('msg.cancel')
                        })
                    })
            },
            getSparePartPositionFcCode() {
                let queryParams = {
                    pageSize: this.searchParams.pageSize,
                    pageNum: this.searchParams.page,
                    strCode: this.searchData.strCode
                }
                if (this.searchData.sppCode != undefined && this.searchData.sppCode != '') {
                    queryParams['sppCode'] = this.searchData.sppCode
                }
                if (this.searchData.sppName != undefined && this.searchData.sppName != '') {
                    queryParams['sppName'] = this.searchData.sppName
                }
                let options = {
                    method: 'GET',
                    url: this.$api.getSparePartPositionFcCode,
                    params: queryParams
                }
                this.$http.request(options).then(response => {
                    if (response.status == 100) {
                        this.tableData = response.data.list
                        this.searchParams.pageCount = response.data.total
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
